import { useLayoutEffect, useState } from "react";
import { MOBILE_BREAKPOINT } from "constants/breakpoints.constants";
import { AppDOM } from "utils/app.utils";
import { useDebounce } from "./useDebounce.hook";
import { useResize } from "./useResize.hook";

type useMobileReturnType = {
  isMobile: boolean;
};

type UseWindowSizeParams = {
  debounceTime?: number;
};

export const useMobile = ({ debounceTime = 100 }: Partial<UseWindowSizeParams> = {}): useMobileReturnType => {
  const { debounce } = useDebounce(debounceTime);

  const [isMobile, setIsMobile] = useState(false);

  const persistWindowSize = () => {
    const width = AppDOM.appContainer?.clientWidth ?? window.innerWidth;
    setIsMobile(width <= MOBILE_BREAKPOINT);
  };

  useLayoutEffect(() => {
    persistWindowSize();
  }, []);

  useResize(() => {
    if (typeof debounceTime !== "undefined") {
      debounce(() => {
        persistWindowSize();
      });
      return;
    }
    persistWindowSize();
  });

  return { isMobile };
};
